module.exports = __webpack_public_path__ + "images/7cb63f5ad5c1fd55e907e5fdc15bf1a2.png";